import { QueryFactory } from "../../../../Common";
export const QGetWageringInformation = QueryFactory("GetWageringInformation");
//# sourceMappingURL=QGetWageringInformation.js.map